// i18n bootstrap — scalable across the whole platform.
// Currently loaded on the public pages (Landing, Login, Register, Forgot/Reset).
// Add new namespaces/keys to the locale JSON files under ./locales.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import sv from "./locales/sv.json";
import en from "./locales/en.json";
import sq from "./locales/sq.json";

export const LANGUAGES = [
  { code: "sv", label: "Svenska", flag: "🇸🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "sq", label: "Shqip", flag: "🇦🇱" },
];

const STORAGE_KEY = "arcquan_lang";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sv: { translation: sv, auto: sv.auto },
      en: { translation: en, auto: en.auto },
      sq: { translation: sq, auto: sq.auto },
    },
    fallbackLng: "sv",
    ns: ["translation", "auto"],
    defaultNS: "translation",
    supportedLngs: ["sv", "en", "sq"],
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    detection: {
      // 1) A saved user choice (localStorage) always wins.
      // 2) On first visit, always default to Swedish (fallbackLng) regardless of browser language.
      order: ["localStorage"],
      lookupLocalStorage: STORAGE_KEY,
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) => {
        const base = String(lng || "").split("-")[0].toLowerCase();
        return ["sv", "en", "sq"].includes(base) ? base : "sv";
      },
    },
    interpolation: { escapeValue: false },
    returnObjects: true,
  });

export default i18n;
